import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomMaterialModule } from '../custom-material/custom-material.module';
import { LimitToPipe } from './pipes/limit-to.pipe';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { ConfirmDialogActionsComponent } from './confirm-dialog-actions/confirm-dialog-actions.component';
import { ContentPlaceholderAnimationComponent } from './content-placeholder-animation/content-placeholder-animation.component';
import { LocalDatePipe } from './pipes/local-date.pipe';
import { YesNoPipe } from './pipes/yes-no.pipe';
import { LayoutComponent } from './layout/layout.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { NewProspectusModalComponent } from './prospectus/new-prospectus-modal/new-prospectus-modal.component';
import { NewVisitModalComponent } from './visit/new-visit-modal/new-visit-modal.component';
import { ActivityModalComponent } from './calendar/activity-modal/activity-modal.component';
import { VisitModalComponent } from './calendar/visit-modal/visit-modal.component';
import { LoadingComponent } from './loading/loading.component';
import { InfoQuoteModalComponent } from './info-quote-modal/info-quote-modal.component';
import { RejectQuoteModalComponent } from './reject-quote-modal/reject-quote-modal.component';
import { EditWorkplanDialogComponent } from './edit-workplan-dialog/edit-workplan-dialog.component';


@NgModule({
  imports: [
    RouterModule,
    CustomMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    NgxSkeletonLoaderModule,
    
  ],
  declarations: [
    ConfirmDialogComponent,
    ConfirmDialogActionsComponent,
    ContentPlaceholderAnimationComponent,
    LimitToPipe,
    LocalDatePipe,
    YesNoPipe,
    LayoutComponent,
    BreadcrumbComponent,
    NewProspectusModalComponent,
    NewVisitModalComponent,
    ActivityModalComponent,
    VisitModalComponent,
    LoadingComponent,
    InfoQuoteModalComponent,
    RejectQuoteModalComponent,
    EditWorkplanDialogComponent,
  ],
  exports: [
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    CustomMaterialModule,
    LimitToPipe,
    ConfirmDialogComponent,
    ConfirmDialogActionsComponent,
    ContentPlaceholderAnimationComponent,
    LocalDatePipe,
    YesNoPipe,
    NgxSkeletonLoaderModule,
    BreadcrumbComponent,
    NewProspectusModalComponent,
    NewVisitModalComponent,
    ActivityModalComponent,
  ],
  entryComponents: [
    ConfirmDialogComponent,
    NewProspectusModalComponent,
    NewVisitModalComponent,
    ActivityModalComponent,
  ]
})
export class SharedModule { }
